import { render, staticRenderFns } from "./TableLoader.vue?vue&type=template&id=09bef68c&scoped=true&"
import script from "./TableLoader.vue?vue&type=script&lang=js&"
export * from "./TableLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bef68c",
  null
  
)

export default component.exports